import { typeByID, typeCreate, typeDestroy, typeList, typeUpdate } from '@/services/agency/ad-types.service'

export default {
	namespaced: true,
	state: {
		// SERVICE TYPE
		typeList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		type: {},

		// STATUS SERVICE TYPE
		typeStatus: 'pending',
		typeSaveStatus: 'init',
		typeDeleteStatus: 'init',
	},
	getters: {
		// SERVICE TYPE
		getTypeList(state) {
			return state.typeList
		},
		getType(state) {
			return state.type
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE TYPE
		getTypeDeleteStatus(state) {
			return state.typeDeleteStatus
		},
		getTypeSaveStatus(state) {
			return state.typeSaveStatus
		},
		getTypeStatus(state) {
			return state.typeStatus
		},
	},
	mutations: {
		// SERVICE TYPE
		TYPE_LIST(state, value) {
			state.typeList = value
		},
		SET_TYPE(state, value) {
			state.type = value
		},

		// STATUS SERVICE TYPE
		TYPE_STATUS(state, value) {
			state.typeStatus = value
		},
		TYPE_SAVE_STATUS(state, value) {
			state.typeSaveStatus = value
		},
		TYPE_DELETE_STATUS(state, value) {
			state.typeDeleteStatus = value
		},
	},
	actions: {
		// Service Type
		async fetchTypeList({ commit }, params) {
			commit('TYPE_STATUS', 'pending')
			commit('TYPE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await typeList(params)
				commit('TYPE_STATUS', 'init')
				commit('TYPE_LIST', data)
				return data
			} catch (error) {
				commit('TYPE_STATUS', 'init')
				throw error
			}
		},
		async fetchTypeByID({ commit }, params) {
			commit('TYPE_STATUS', 'pending')
			try {
				const { data } = await typeByID(params)
				commit('TYPE_STATUS', 'init')
				commit('SET_TYPE', data.data)
				return data
			} catch (error) {
				commit('TYPE_STATUS', 'init')

				return error
			}
		},
		async saveNewType({ commit }, params) {
			commit('TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await typeCreate(params)
				commit('TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateType({ commit }, params) {
			commit('TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await typeUpdate(params)
				commit('TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteTypeByID({ commit }, params) {
			commit('TYPE_DELETE_STATUS', 'pending')
			try {
				const { data } = await typeDestroy(params)
				commit('TYPE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('TYPE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
